module.exports = __webpack_public_path__ + "media/img/pages/companies/vermogenszentrum-d36fc7b5b50e73033bd6670333df38e6.png";